import * as React from "react";
const SvgFiRrEngine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.5 9H21v-.5C21 7.122 19.878 6 18.5 6H16V3h3a1 1 0 0 0 0-2h-8a1 1 0 0 0 0 2h3v3h-2.563a2.99 2.99 0 0 0-2.304 1.08L7.532 9H7.5A2.503 2.503 0 0 0 5 11.5V13H2v-3a1 1 0 0 0-2 0v8a1 1 0 0 0 2 0v-3h3v2.171c0 .801.312 1.555.879 2.122l1.828 1.828c.566.567 1.32.879 2.122.879H18.5c1.208 0 2.217-.86 2.45-2h.55c1.378 0 2.5-1.122 2.5-2.5v-6c0-1.378-1.122-2.5-2.5-2.5m.5 8.5a.5.5 0 0 1-.5.5H20a1 1 0 0 0-1 1v.5a.5.5 0 0 1-.5.5H9.829a1 1 0 0 1-.708-.293l-1.828-1.828A1 1 0 0 1 7 17.171V11.5a.5.5 0 0 1 .5-.5H8a1 1 0 0 0 .768-.36l1.901-2.28c.19-.229.47-.36.768-.36H18.5a.5.5 0 0 1 .5.5V10a1 1 0 0 0 1 1h1.5a.5.5 0 0 1 .5.5z"
    />
  </svg>
);
export default SvgFiRrEngine;
